<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Canteen Meal Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                 <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id" :items="academic_year_list" item-text="academicyear" label="Select Academic Year" outlined 
                     @click="show = false" persistent-hint hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" :loading="loader" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-data-table v-if="learner_canteen_meal_history != ''" :headers="headers" :items="learner_canteen_meal_history" class="elevation-1 mytable" dense :search="search">
                    <template v-slot:item.meal_count="{ item }">
                        <v-btn link @click="meal_history(item.meal_details)"> {{ item.meal_count }}</v-btn>
                    </template>
                </v-data-table>
        </v-card>
        <v-dialog v-model="dialog_meal_details" max-width="800px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-data-table v-if="meal_details != ''" :headers="headers_1" :items="meal_details" class="elevation-1 mytable" dense :search="search">
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="dialog_meal_details = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
      
        data: () => ({
            child_info: null,
            children: [],
            show: false, 
            selected_children: null,
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: false,
            current_ay: "",
            search: "",
            s3url: "",
            leaner_std: null,
            leaner_div: null,
            academic_year_list:[],
            selected_ay:null,
            learner_canteen_meal_history:[],
            headers: [
                    {
                        text: "Sr. No.",
                        align: "left",
                        sortable: false,
                        value: "sr_no",
                    },
                    {
                        text: "Installment",
                        align: "left",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Meal Count",
                        align: "left",
                        sortable: false,
                        value: "meal_count",
                    },
                ],
                headers_1: [
                    {
                        text: "Sr. No.",
                        align: "left",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Meal Date",
                        align: "left",
                        sortable: false,
                        value: "date",
                    },
                ],
                meal_details:[],
                dialog_meal_details:false
        }),
        methods: {
            meal_history(meal_details){
                this.meal_details = []
                this.meal_details = meal_details
                this.dialog_meal_details = true
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async getDetails(){
                this.loader = true
                const formData = {
                    registration_no: this.selected_children.registration_number,
                    ay: this.selected_ay
                };
                try {
                  const res = await axios.post("/Canteen/getCanteenInstallmentMealReport", formData);
                  if (res.data.flag == "YES") {
                    this.learner_canteen_meal_history = res.data.learner_canteen_meal_history
                    this.loader = false
                  }
                  if (res.data.flag == "NO") {
                      this.showSnackbar("red", res.data.fmsg); // show snackbar
                      this.loader = false
                  }
              } catch (error) {
                  this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  this.loader = false
              } finally {
                this.loader = false
              }
            }
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            let org_id = localStorage.getItem("EPS-tenant");
          
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.academic_year_list = res.data.academicyearlist
                            this.selected_ay = res.data.current_ay;
                            this.selected_children = this.children[0];
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
    td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
     .scroll {
        overflow-x: scroll;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .noborder {
        border: none;
    }
    .noborder:hover {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .text-color2 {
        font-weight: bold;
        color: darkseagreen;
    }
    .text-color1 {
        font-weight: bold;
        color: darkblue;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-grad {
        /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
    }
    .btn-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: black;
        box-shadow: 0 0 20px rgb(190, 187, 187);
        border-radius: 10px;
        display: block;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: black;
        text-decoration: none;
    }
    .btn1-grad {
        background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
    }
    .btn1-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
    }

    .btn1-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
.flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
